/* eslint-disable no-shadow */

import ufeApi from 'services/api/ufeApi';
import updateProfile from 'services/api/profile/updateProfile';

import constants from 'services/api/profile/constants';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const { EmailSubscriptionTypes, SubscriptionStatus, PromotionalEmailsPrefsFrequency } = constants;

function getNotificationsAndRemindersPreferences(userProfileId) {
    const selectedStore = Storage.session.getItem(LOCAL_STORAGE.SELECTED_STORE);
    const storeId = selectedStore?.storeId || '';
    const biAccountId = Storage.local.getItem(LOCAL_STORAGE.USER_DATA)?.profile?.beautyInsiderAccount?.biAccountId || '';
    const { enableConciergePickupUS = false } = Sephora.configurationSettings;
    const { enableConciergePickupCA = false } = Sephora.configurationSettings;
    const preferredZipCode = Storage.session.getItem(LOCAL_STORAGE.PREFERRED_ZIP_CODE) || selectedStore?.address?.postalCode;

    const url = `/gapi/users/profiles/${userProfileId}?propertiesToInclude=emailSubscriptionInfo&storeId=${storeId}&biAccountId=${biAccountId}&enableConciergePickupUS=${enableConciergePickupUS}&enableConciergePickupCA=${enableConciergePickupCA}&preferredZipCode=${preferredZipCode}`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => {
        let promise;

        if (data.errorCode) {
            promise = Promise.reject(data);
        } else {
            const subscriptions = data.emailSubscriptionInfo || [];

            const triggeredSubs = subscriptions.filter(data => data.subscriptionType === EmailSubscriptionTypes.TRIGGERED)[0];

            const subscribed = (triggeredSubs && triggeredSubs.subscriptionStatus === SubscriptionStatus.SUBSCRIBED) || false;

            const prefs = { subscribed };

            promise = Promise.resolve(prefs);
        }

        return promise;
    });
}

function setNotificationsAndRemindersPreferences(prefs) {
    const defaultPayload = {
        fragmentForUpdate: 'EMAIL_SUBSCRIPTION',
        emailSubscriptionInfo: {
            subScribeToEmails: prefs.subscribed,
            subscriptionType: EmailSubscriptionTypes.TRIGGERED
        }
    };

    const shouldShowCommunicationLanguagePrefs = Sephora?.configurationSettings?.communicationLanguagePrefsEnabled || false;

    let clpcPayload = {};

    if (shouldShowCommunicationLanguagePrefs) {
        const subscriptionPreferredLanguage = prefs.subscriptionPreferredLanguage || '';
        const subscriptionPreferredCountry = prefs.subscriptionPreferredCountry || '';
        clpcPayload = {
            subscriptionPreferredLanguage: subscriptionPreferredLanguage,
            subscriptionPreferredCountry: subscriptionPreferredCountry,
            subscriptions: [
                {
                    subscriptionRegion: subscriptionPreferredCountry,
                    subscriptionFrequency: PromotionalEmailsPrefsFrequency.DAILY,
                    subscriptionType: EmailSubscriptionTypes.TRIGGERED,
                    countryLocation: subscriptionPreferredCountry,
                    subscriptionStatus: prefs.subscribed ? SubscriptionStatus.SUBSCRIBED : SubscriptionStatus.UNSUBSCRIBED,
                    subscriptionLanguage: subscriptionPreferredLanguage
                }
            ]
        };
    }

    const payloadToSend = !shouldShowCommunicationLanguagePrefs ? defaultPayload : clpcPayload;

    return updateProfile(payloadToSend);
}

export default {
    getNotificationsAndRemindersPreferences,
    setNotificationsAndRemindersPreferences
};
